import { Stack, Table, TableCell, TableHead, TableRow } from "@mui/material";
import { useState } from "react";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

const RTStructHeader = ({
  changeOrdering,
}: {
  changeOrdering: (ordering: "asc" | "desc") => void;
}) => {
  const [ordering, setOrdering] = useState<"asc" | "desc">("desc");

  const handleChangeOrdering = () => {
    const newOrdering = ordering === "asc" ? "desc" : "asc";
    setOrdering(newOrdering);
    changeOrdering(newOrdering);
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell sx={{ width: "40%", minWidth: "40%" }}>
            <Stack
              onClick={handleChangeOrdering}
              direction="row"
              sx={{
                alignItems: "center",
                gap: 1,
                cursor: "pointer",
              }}
            >
              {ordering == "desc" ? (
                <ArrowDownward fontSize="small" color="secondary" />
              ) : (
                <ArrowUpward fontSize="small" color="secondary" />
              )}
              RT structure sets
            </Stack>
          </TableCell>
          <TableCell sx={{ width: "40%", minWidth: "40%" }}>
            Associated CT series
          </TableCell>
          <TableCell sx={{ width: "20%", minWidth: "20%" }}>Slices</TableCell>
        </TableRow>
      </TableHead>
    </Table>
  );
};

export default RTStructHeader;
